import {PokerOutcardComponent} from '@interface/index';
import {getPokerBack, getPokerOutcardImage} from '@utils/index';
import useCommon from '@utils/hooks/common';
import classNames from 'classnames';
import {useEffect, useState, useRef} from 'react';
import styles from './styles';

const FLIP_DELAY = 300;

const PokerOutcard = (props: PokerOutcardComponent) => {
  const {
    suit,
    rank,
    className,
    cardClassName,
    state = 'NORMAL',
    isInitiallyFlipped,
    cardSize,
  } = props;
  const {classes} = useCommon({
    withStyles: {styles, hasProps: true, props},
  });
  const [isFlipped, setIsFlipped] = useState(isInitiallyFlipped);
  const flipTimer = useRef<NodeJS.Timeout>();

  useEffect(() => {
    flipTimer.current = setTimeout(() => {
      setIsFlipped(true);
    }, FLIP_DELAY);
    return () => {
      clearTimeout(flipTimer.current);
    };
  }, []);

  const getClassNamesOfCard = () => {
    return classNames({[classes.cardImage]: typeof cardClassName === 'undefined'}, cardClassName);
  };

  const getContainerClassName = () => {
    if (state === 'RAISED') {
      return classes.raised;
    }
    if (state === 'DARKEN') {
      return classes.darken;
    }
    return null;
  };

  return (
    // inline
    <article className={classNames(classes.cardContainer, className, getContainerClassName())}>
      <div className={classNames(classes.goldBorder, {show: state === 'RAISED'})}>
        <div
          className={classNames(classes.innerContainer, {
            flipped: isFlipped,
            [classes.small]: cardSize === 'small',
            [classes.medium]: cardSize === 'medium' || typeof cardSize === 'undefined',
            show: state === 'RAISED',
          })}
        >
          <img
            src={getPokerOutcardImage({suit, rank})}
            alt=""
            className={classNames(getClassNamesOfCard(), classes.frontFace)}
          />
          <img
            src={getPokerBack()}
            alt=""
            className={classNames(getClassNamesOfCard(), classes.backFace)}
          />
        </div>
      </div>
    </article>
  );
};

export default PokerOutcard;
